import { Stack, Text } from '@mantine/core';
import { useQuery } from '@tanstack/react-query';
import { FieldValues } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { userOptions } from '@/module/Nomen/User/model/UserModel';

import { AsyncSelectControl, AsyncSelectControlProps } from '@/core/components';

type UserSelectControlProps<T extends FieldValues> = Omit<
  AsyncSelectControlProps<T>,
  'isError' | 'isLoading' | 'options'
>;

export function UserSelectControl<T extends FieldValues>(props: UserSelectControlProps<T>) {
  const { data, isLoading, isError } = useQuery(userOptions.getAll());
  const { t } = useTranslation();

  return (
    <AsyncSelectControl
      isError={isError}
      isLoading={isLoading}
      options={(data ?? []).map(j => ({ id: j.id, name: j.email }))}
      description={t('users.select.limit')}
      limit={100}
      nothingFoundMessage={
        <Stack>
          <Text ta="center">{t('users.select.nothingFound')}</Text>
        </Stack>
      }
      {...props}
    />
  );
}
